import { render, staticRenderFns } from "./SubscriptionSendMessage.vue?vue&type=template&id=777024a8&scoped=true"
import script from "./SubscriptionSendMessage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionSendMessage.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionSendMessage.vue?vue&type=style&index=0&id=777024a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777024a8",
  null
  
)

export default component.exports